import React, { ReactNode } from 'react';
import styled from 'styled-components/macro';
import { colourNeutral09, colourNeutral10 } from '../../../styling/colours';
import { fontWeightBold } from '../../../styling/fonts';
import { spacing01, spacing02 } from '../../../styling/spacing';
import { NODE_WIDTH, SMALL_NODE_WIDTH_SCALING } from '../../shared/quote-or-design-form/map/map-helpers/mapHelpers';
import { SourceHandle, TargetHandle } from '../../shared/quote-or-design-form/map/node-types/Handle';

type Props = {
  icon: ReactNode;
  stats: Array<string>;
  children?: ReactNode;
  hasSource: boolean;
  hasTarget: boolean;
  title: string;
  className?: string;
};
export const MapFlowNodeReadOnly = ({ icon, stats, children, hasSource, hasTarget, title, className }: Props) => {
  const statsToDisplay = stats.filter(stat => stat !== '');
  return (
    <FlowNode className={className}>
      <div>
        <FlowNodeTitle>
          {icon} {title}
        </FlowNodeTitle>
        {children}
        <Statistics>
          {statsToDisplay.map((stat, index) => (
            <Statistic key={index}>{stat}</Statistic>
          ))}
        </Statistics>
      </div>
      {hasTarget && <TargetHandle />}
      {hasSource && <SourceHandle />}
    </FlowNode>
  );
};

export const FlowNode = styled.div`
  width: ${NODE_WIDTH / SMALL_NODE_WIDTH_SCALING}px;
  border: 2px solid ${colourNeutral09};
  padding: ${spacing02};
  background: ${colourNeutral10};
`;

const FlowNodeTitle = styled.title`
  display: flex;
  align-items: center;
  svg {
    margin-right: ${spacing01};
  }
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: ${fontWeightBold};
  font-size: 10px;
`;

const Statistics = styled.ul`
  font-size: 10px;
  list-style-type: none;
  padding: 0;
`;

const Statistic = styled.li`
  text-align: right;
`;
